// extracted by mini-css-extract-plugin
module.exports = {"dueDate":"dueDate_dueDate__zsLFS","overdue":"dueDate_overdue__5hwCG","complete":"dueDate_complete__1wE-l","bold":"dueDate_bold___JusD","left":"dueDate_left__1Uv3b"};